import { render, staticRenderFns } from "./notification-panel-header.vue?vue&type=template&id=5f727624&scoped=true"
import script from "./notification-panel-header.vue?vue&type=script&lang=js"
export * from "./notification-panel-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f727624",
  null
  
)

export default component.exports